import { CxEvent } from '@spartacus/core';

export class Ga4GgFindADealerClickEvent extends CxEvent {
  event?: string;
  action?: string;
  search_term?: string;
  visitor_type?: string;
}
